import { Card, CardContent, makeStyles, TextField, Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import DateFilter from '../../atoms/Dates/DateFilter';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingBottom: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    display: 'flex',
    flexFlow: 'column'
  },
  filters: {
    display: 'flex',
	  justifyContent: 'space-around',
	  alignContent: 'center'
  },
  group: {
    display: 'flex',
    flexDirection: 'row'
  },
  priceSelect: {
    justifyContent: 'flex-start',
    minWidth: 250,
  },
  status: {
    justifyContent: 'flex-start',
    minWidth: 250,
  }
}));

interface Props {
  onFiltersUpdated: Function
}

const Filters = (props: Props) => {
  const classes = useStyles();
  const [customer, setCustomer] = useState<String>('');
  const [validCustomer, setValidCustomer] = useState<boolean>(true);
  const [filters, setFilters] = useState<any>({});

  useEffect(() => {
    props.onFiltersUpdated(filters); 
  }, [filters]);

  const handleCustomerIdChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value: String = event.target.value as String;
    setCustomer(value);
    setValidCustomer(
      value === null || value === undefined || value === '' || value.startsWith('cus_')
    );
  };

  const handleSearchButton = (_:any) => {
    setFilters((prevFilters: any) => {
      if (customer.length === 0 || !validCustomer) {
        delete prevFilters['customer'];
      } else {
        prevFilters.customer = customer as string;
      }
      return {...prevFilters};
    });
  };

  return (
    <div className={classes.container}>
      <Card>
        <CardContent>
          <div className={classes.filters}>
            <div className={classes.group}>
              <TextField
                error={!validCustomer}
                id="customerId"
                label="ID Client Stripe"
                variant="outlined"
                placeholder="cus_****"
                onChange={handleCustomerIdChange}
                value={customer}
              />
              <Button variant="outlined" color="primary" onClick={handleSearchButton} disabled={!validCustomer}>Rechercher</Button>
            </div>
            <div className={classes.group}>
              <DateFilter
                onFiltersUpdated={(parameters: any) => {
                  setFilters((prevFilters: any) => {
                    if (prevFilters.customer)
                      return { customer: prevFilters.customer, ...parameters };
                    return {...parameters};
                  });
                }}
                name="created"
              ></DateFilter>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default Filters;